import { variant } from 'styled-system';

const semanticMap = {
  positive: 'green',
  warning: 'orange',
  critical: 'red',
};
const createSemanticType = (type) => {
  return {
    color: 'neutral.0',
    backgroundColor: `${semanticMap[type]}.50`,
    '@media (hover: hover)': {
      ':hover:not(:disabled)': {
        backgroundColor: `${semanticMap[type]}.70`,
      },
    },
    ':active:not(:disabled)': {
      backgroundColor: `${semanticMap[type]}.30`,
    },
    ':disabled': {
      backgroundColor: 'neutral.30',
      color: 'neutral.50',
    },
  };
};
const createInvertedSemanticType = (type) => {
  return {
    color: `${semanticMap[type]}.50`,
    backgroundColor: 'transparent',
    '@media (hover: hover)': {
      ':hover:not(:disabled)': {
        color: `${semanticMap[type]}.70`,
      },
    },
    ':active:not(:disabled)': {
      color: `${semanticMap[type]}.70`,
    },
    ':disabled': {
      backgroundColor: 'neutral.30',
      color: 'neutral.50',
    },
  };
};

const typeVariant = ({ theme, inverted }) => {
  if (inverted)
    return variant({
      prop: 'variant',
      variants: {
        primary: {
          color: 'button.primary.inverted.color',
          bg: 'button.primary.inverted.bgColor',
          border: 'unset',

          '@media (hover: hover)': {
            ':hover:not(:disabled)': {
              bg: 'button.primary.inverted.hover.bgColor',
            },
          },
          ':active': {
            bg: 'button.primary.inverted.active.bgColor',
          },
          ':focus': {},
          ':disabled': {
            bg: 'button.primary.inverted.disabled.bgColor',
            color: 'button.primary.inverted.disabled.color',
          },
        },
        secondary: {
          color: 'button.secondary.inverted.color',
          bg: 'transparent',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
          '@media (hover: hover)': {
            ':hover:not(:disabled)': {
              bg: 'transparent',
              color: 'button.secondary.inverted.color',
              boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
              opacity: '0.68',
            },
          },
          ':active': {
            bg: 'transparent',
            color: 'button.secondary.inverted.color',
            borderColor: 'button.secondary.inverted.color',
            boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['0']}`,
            opacity: '0.68',
          },
          ':disabled': {
            bg: 'transparent',
            color: 'button.secondary.inverted.disabled.color',
            borderColor: 'button.secondary.disabled.inverted.color',
            boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['30']}`,
          },
        },
        /**
         * @deprecated
         * no default button on cobalt design system
         * */
        text: {
          color: 'button.text.inverted.color',
          bg: 'transparent',
          borderColor: 'transparent',
          '@media (hover: hover)': {
            ':hover:not(:disabled)': {
              color: 'button.text.inverted.hover.color',
              bg: `${theme.colors.neutral['0']}33`,
            },
          },
          ':active:not(:disabled)': {
            color: 'button.text.inverted.color',
            bg: 'transparent',
          },
          ':disabled': {
            color: 'button.text.inverted.disabled.color',
          },
        },
        positive: createInvertedSemanticType('positive'),
        warning: createInvertedSemanticType('warning'),
        critical: createInvertedSemanticType('critical'),
        deal: {
          color: 'neutral.0',
          backgroundColor: 'deals.50',
        },
      },
    });

  return variant({
    prop: 'variant',
    variants: {
      primary: {
        color: 'button.primary.color',
        bg: 'button.primary.bgColor',
        border: 'unset',

        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'button.primary.hover.bgColor',
          },
        },
        ':active': {
          bg: 'button.primary.active.bgColor',
        },
        ':focus': {},
        ':disabled': {
          bg: 'button.highlight.disabled.bgColor',
          color: 'button.highlight.disabled.color',
        },
      },
      secondary: {
        color: 'button.secondary.color',
        bg: 'button.secondary.bgColor',
        boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'button.secondary.hover.bgColor',
            color: 'button.secondary.hover.color',
            boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
          },
        },
        ':active': {
          bg: 'button.secondary.hover.bgColor',
          color: 'button.secondary.hover.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
        },
        ':disabled': {
          bg: 'button.secondary.disabled.bgColor',
          color: 'button.secondary.disabled.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['50']}`,
        },
      },
      /**
       * @deprecated
       * no default button on cobalt design system
       * */
      text: {
        color: 'button.text.color',
        bg: 'transparent',
        borderColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'button.text.hover.color',
            backgroundColor: 'button.text.hover.bgColor',
          },
        },
        ':active:not(:disabled)': {
          color: 'button.text.active.color',
          backgroundColor: 'button.text.active.bgColor',
        },
        ':disabled': {
          color: 'button.text.disabled.color',
        },
      },
      positive: createSemanticType('positive'),
      warning: createSemanticType('warning'),
      critical: createSemanticType('critical'),
      deal: {
        color: 'neutral.0',
        backgroundColor: 'deals.50',
      },
    },
  });
};

export default typeVariant;
